export const COMPANY = {
  name: "Fliesen-Geffke",
  owner: "Lars Geffke",
  ownerTitle: "Fliesen-, Platten- und Mosaiklegermeister",
  founded: "1. April 2004",
  street: "Heidebruch 34",
  city: "21079 Hamburg",
  district: "Heimfeld/Harburg",
  phone: "040 32519555",
  phoneLink: "tel:+494032519555",
  fax: "040 32519935",
  email: "info@fliesen-geffke.de",
  hours: [
    { days: "Mo – Do", time: "07:00 – 16:30 Uhr" },
    { days: "Freitag", time: "07:00 – 12:00 Uhr" },
    { days: "Sa / So", time: "geschlossen" },
  ],
  vatId: "DE234010308",
  register: "Handwerksrolle der Handwerkskammer Hamburg",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Heidebruch+34%2C+21079+Hamburg",
  team: [
    "Y. Geffke",
    "D. Thiesen",
    "C. Masia",
    "T. Brinckmann",
    "A. Shehu",
    "M. Brinckmann",
    "D. Zilienski",
  ],
};

export const SERVICES = [
  {
    icon: "Grid3x3",
    title: "Fliesen, Platten & Mosaik",
    text: "Fachgerechte Verlegung von Fliesen, Platten, Klinker, Mosaik und Naturstein — präzise bis ins Detail.",
  },
  {
    icon: "Bath",
    title: "Bad & Küche",
    text: "Neuverlegung und Komplettsanierung — vom kleinen Gäste-WC bis zum großzügigen Wellness-Bad.",
  },
  {
    icon: "Home",
    title: "Wohnräume & Flure",
    text: "Boden- und Wandfliesen für Wohnräume und Flure — langlebig, pflegeleicht und stilvoll.",
  },
  {
    icon: "Building2",
    title: "Gewerbliche Räume",
    text: "Ladenbau, Büro, Gastronomie und öffentliche Einrichtungen — termintreu auch bei großen Flächen.",
  },
  {
    icon: "Sun",
    title: "Balkon- & Terrassensanierung",
    text: "Dauerhaft dichte und frostsichere Lösungen für den Innen- und Außenbereich.",
  },
  {
    icon: "Gem",
    title: "Naturstein, Marmor & Granit",
    text: "Edle Oberflächen aus Naturstein, Marmor, Granit und Kunststein — meisterhaft verarbeitet.",
  },
  {
    icon: "ClipboardCheck",
    title: "Beratung & Planung",
    text: "Alles aus einer Hand: fachliche Beratung, Planung und Ausführung — persönlich betreut.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Kontakt & Beratung",
    text: "Kostenlose, fachlich kompetente Erstberatung — telefonisch oder direkt bei Ihnen vor Ort.",
  },
  {
    step: "02",
    title: "Angebot",
    text: "Sie erhalten ein transparentes, individuelles Angebot — ohne versteckte Kosten.",
  },
  {
    step: "03",
    title: "Ausführung",
    text: "Sauber, präzise und termintreu — ausgeführt durch unser eigenes, eingespieltes Team.",
  },
  {
    step: "04",
    title: "Abnahme",
    text: "Persönliche Endabnahme durch Lars Geffke — Ihre Zufriedenheit ist unser Maßstab.",
  },
];

export const REFERENCES = [
  "Daimler AG (Niederlassung Bostelbek)",
  "tesa Hamburg",
  "Jungheinrich",
  "Freie und Hansestadt Hamburg",
  "SBH | Schulbau Hamburg",
  "Holiday Inn (Hotel)",
  "Deutsches Rotes Kreuz (Kitas)",
  "Arbeiter-Samariter-Bund",
  "Gesundheitszentrum Harburg",
  "fördern & wohnen AöR",
  "City Center Bergedorf",
  "PM Projektimmobilien (Neubau, 38 Wohneinheiten)",
  "HS Hotel (Umbau, 58 Zimmer)",
  "Alt Lohbrügger Hof (Hotel)",
];

export const STATS = [
  { value: 41, suffix: "+", label: "Jahre Berufserfahrung" },
  { value: 2004, suffix: "", prefix: "seit ", label: "eigener Meisterbetrieb", noSeparator: true },
  { value: 20, suffix: "+", label: "Referenzprojekte" },
  { value: 100, suffix: " %", label: "eigenes Team — keine Subunternehmer" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  marble:
    "https://images.unsplash.com/photo-1558346648-9757f2fa4474?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  craftsman:
    "https://images.unsplash.com/photo-1523413363574-c30aa1c2a516?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  bathroom:
    "https://images.unsplash.com/photo-1744025098626-66c0b9cb1ba8?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
};
